export default __webpack_public_path__ + "static/media/magnifier.62916ec4.svg";